import * as React from "react";

import { useDispatch } from "react-redux";

import { Button } from "semantic-ui-react";

import { ThunkDispatch } from "redux-thunk";

import { MessagingModal, MessagingModalProps } from "./MessagingModal";

interface MessagingModalButtonProps {
    caseId: string;
    buttonText: string;
    customerId: string;
    action?: () => void;
}

const MessagingModalButton: React.FC<MessagingModalButtonProps> = ({ caseId, buttonText, customerId, action }) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const [openModal, setOpenModal] = React.useState<boolean>(false);

    const invokeAction = () => {
        if (action) {
            dispatch(action());
        }
    };

    const onCloseModal = React.useCallback(() => {
        invokeAction();
        setOpenModal(false);
    }, []);

    const onOpenModal = React.useCallback(() => {
        setOpenModal(true);
    }, []);

    const messagingModalProps: MessagingModalProps = {
        openModal,
        onCloseModal,
        caseId,
        customerId
    };

    return (
        <>
            <Button onClick={onOpenModal}>{buttonText}</Button>
            <MessagingModal {...messagingModalProps} />
        </>
    );
};

export {
    MessagingModalButton
};
